uniform vec3 color1;    
uniform vec3 color2;      
uniform float edgeStart; 
uniform float edgeEnd;    
varying vec3 vNormal;
varying vec3 vViewPosition;

void main() {
    vec3 N = normalize(vNormal);
    vec3 V = normalize(vViewPosition);
    float rim = 1.0 - max(dot(N, V), 0.0);
    float factor = smoothstep(edgeStart, edgeEnd, rim);

    vec3 finalColor = mix(color1, color2, factor);

    gl_FragColor = vec4(finalColor, factor*0.7);
}
